import request from '@/utils/request'
import { getToken, TokenKey } from '@/utils/auth'
//医助代办检查单列表
export function getCheckList(data) {
  return request({
    url: '/health-emr/checklist/checklistList',
    method: 'post',
    data
  })
}
//医助检查表单 轮播图
export function getBannerList(data) {
  return request({
    url: '/health-emr/checklist/banner',
    method: 'get',
    params: data
  })
}

//检查单详情
export function checklistDetail(data) {
  return request({
    url: '/health-emr/checklist/checklistDetail',
    method: 'get',
    params: data
  })
}
//检查表单 录入
export function checklistItemFill(data) {
  return request({
    url: '/health-emr/checklist/checklistItemFill',
    method: 'post',
    data
  })
}
//检查表单 录入初始化树

export function checklistItemInit(data) {
  return request({
    url: '/health-emr/checklist/checklistItemInit',
    method: 'get',
    params: data
  })
}

/**
 * 获取我的就诊科室
 */
export function getDepartmentList() {
  return request({
    url: '/cure/department/list',
    method: 'get'
  })
}

// 获取城市列表
export function getCitys() {
  return request({
    url: '/health-b2c/addreses/citys',
    method: 'get'
  })
}

// 查看患者健康信息
export function getHealthInfo(data) {
  return request({
    url: '/health-emr/health-info/detail',
    method: 'GET',
    params: data
  })
}
// 查看患者健康信息
export function getPatientInfo(data) {
  return request({
    url: '/health-emr/health-info/patient-info',
    method: 'GET',
    params: data
  })
}

// 疾病史列表
export function getDiseaseHistory(data) {
  return request({
    url: '/health-emr/health-info/list/disease-history',
    method: 'GET',
    params: data
  })
}

// 生活方式列表
export function getLifeStyle(data) {
  return request({
    url: '/health-emr/health-info/list/life-style',
    method: 'GET',
    params: data
  })
}

//保存
export function saveInfo(data) {
  return request({
    url: '/health-emr/health-info/save',
    method: 'POST',
    data
  })
}

// 添加生活方式
export function addLifeStyle(data) {
  return request({
    url: '/health-emr/emr/life-style/add-for-da',
    method: 'POST',
    data
  })
}

// 上传就医记录
export function addMedicalRecords(data) {
  return request({
    url: '/health-emr/emr/record/addRecordByUserId',
    method: 'POST',
    data
  })
}

// 保存基本信息
export function saveBaseInfo(data) {
  return request({
    url: '/health-emr/health-info/saveBase',
    method: 'POST',
    data
  })
}

//保存病史记录
export function saveMedicalHistory(data) {
  return request({
    url: '/health-emr/health-info/saveMedicalHistory',
    method: 'POST',
    data
  })
}

// //门诊病历详情
// export function getOfflineCaseDetail(data) {
//   return request({
//     url: '/health-emr/health-archives/offline/case/detail',
//     method: 'GET',
//     params: data
//   })
// }
// 获取诊断
export function getDiagnosis(data) {
  // return request({
  //   url: '/health-recommend/diagnosis/search',
  //   method: 'POST',
  //   params: data
  // })
  return request({
    url: '/health-recommend/diagnosis/search/new',
    method: 'POST',
    params: data
  })
}

// 获取历史诊断
export function getHistoryList(data) {
  return request({
    url: '/health-recommend/diagnosis/history/list',
    method: 'GET',
    params: data
  })
}

//获取线下活动
export function getActivity(data) {
  return request({
    url: '/health-recommend/pres-offline/activity/get ',
    method: 'GET',
    data
  })
}

// 获取线下活动药品列表
export function getActivityMedicationList(data) {
  return request({
    url: '/health-doctor/activity/medication/list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取门诊病历初始化信息
GET /health-emr/health-archives/offline/case/init
接口ID：23812703
接口地址：https://www.apifox.cn/web/project/1098437/apis/api-23812703
 *
 */
export function getOfflineCaseInit(data) {
  return request({
    url: '/health-emr/health-archives/offline/case/init',
    method: 'GET',
    params: data
  })
}

/**
 * /health-emr/health-archives/offline/case/save
 * 新增门诊病历
 */
export function saveOfflineCase(data) {
  return request({
    // url: '/health-emr/offline/case/save',
    url: '/health-emr/offline/case/supplementMedicalRecord',
    method: 'POST',
    data
  })
}
export function updateOfflineCase(data) {
  return request({
    // url: '/health-emr/offline/case/update',
    url: '/health-emr/offline/case/supplementMedicalRecord/update',
    method: 'POST',
    data
  })
}

// 线上病历列表
export function onLineRecordList(data) {
  return request({
    url: '/health-emr/health-archives/online/case/list',
    method: 'get',
    params: data
  })
}
// 线上病历详情
export function onLineRecordDetail(data) {
  return request({
    url: '/health-emr/health-archives/online/case/detail',
    method: 'get',
    params: data
  })
}
// 门诊病历列表
export function offLineRecordList(data) {
  return request({
    url: '/health-emr/offline/case/list',
    method: 'get',
    params: data
  })
}
// 门诊病历详情（就诊记录-门诊就诊详情）
export function offLineRecordDetail(data) {
  return request({
    url: '/health-emr/offline/case/detail',
    method: 'get',
    params: data
  })
}
// 预门诊病历详情（判断是否存在预门诊病历调用）
export function isDetailIllnessPre(data) {
  return request({
    url: '/health-emr/offline/case/detailPreByUcUserId',
    method: 'get',
    params: data
  })
}

// 最近一次补充诊疗记录权限设置查询接口

export function detailRecordPermission(data) {
  return request({
    url: '/health-emr/offline/case/recentSupplementMedicalRecordPermission',
    method: 'get',
    params: data
  })
}
// 预门诊病历详情（判断是否存在预门诊病历调用）
export function isDetailIllnessPreById(data) {
  return request({
    url: '/health-emr/offline/case/detailPre',
    method: 'get',
    params: data
  })
}
// 查询服务事项类型
export function getMattersList(data) {
  return request({
    url: '/health-doctor-assistant/tccc/getMattersList',
    method: 'get',
    params: { role: data }
  })
}
// 更新服务事项内容
export function updateMatters(data) {
  return request({
    url: '/health-doctor-assistant/tccc/update-cdr-matters',
    method: 'POST',
    data: data
  })
}

// 预门诊病历详情（判断是否存在预门诊病历调用）
export function recentDiagnosisInfo(data) {
  return request({
    url: '/health-emr/offline/case/recentDiagnosisInfo',
    method: 'get',
    params: data
  })
}
// 补充诊疗记录删除
export function deleteMedicalRecord(data) {
  return request({
    url: '/health-emr/offline/case/supplementMedicalRecord/v2/remove',
    method: 'POST',
    data: data
  })
}
// 修改补充诊疗记录V2
export function updateOfflineCaseV2(data) {
  return request({
    // url: '/health-emr/offline/case/update',
    url: '/health-emr/offline/case/supplementMedicalRecord/v2/update',
    method: 'POST',
    data
  })
}

// his门诊病历详情
export function hisOffLineRecordDetail(data) {
  return request({
    url: '/health-emr/offline/case/his/details',
    method: 'POST',
    data
  })
}
// 【BD端】药品搜索结果列表（全部、中西药品、协定方、健康用品）
export function aggregateSearch(data) {
  return request({
    url: '/health-doctor/product/aggregateSearch/BD',
    method: 'POST',
    data
  })
}

// 【BD端】推荐方栏目
export function getRecommendedList(data) {
  return request({
    url: '/health-recommend/combination/main/recommended/list/BD/v2',
    method: 'POST',
    data
  })
}

// 字典用药禁忌
export function getDictByType(data) {
  return request({
    url: '/health-cms/product/dict/getDictByType',
    method: 'get',
    params: data
  })
}

// 【新】保存健管预病历
export function saveDoctorAssistantAdvanceMedicalRecord(data) {
  return request({
    url: '/health-recommend/advanceMedicalRecord/saveDoctorAssistantAdvanceMedicalRecord',
    method: 'POST',
    data
  })
}

// 【新】预病历匹配接口/返回价格
export function rpMatchRecommend(data) {
  return request({
    url: '/health-recommend/prescription/main/query/rpMatchRecommend',
    method: 'POST',
    data
  })
}

// 【BD端】获取诊后病程服务费包
export function queryCourseDiseaseServiceFee(data) {
  return request({
    url: '/health-recommend/prescription/price/queryCourseDiseaseServiceFee/BD',
    method: 'GET',
    params: data
  })
}

// 【新】协定方详情
export function prescriptionInfo(data) {
  return request({
    url: '/health-recommend/prescription/main/import/chinese/prescription/info/BD',
    method: 'POST',
    data
  })
}

// 【新】获取医患诊疗费配置
export function getFee(data) {
  return request({
    url: '/health-recommend/prescription/getFee',
    method: 'POST',
    data
  })
}

// 【新】健管预病历列表
export function listAdvanceMedicalRecord(data) {
  return request({
    url: '/health-recommend/advanceMedicalRecord/listAdvanceMedicalRecord',
    method: 'POST',
    data
  })
}

// 【老】预病历详情
export function getMedicalRecordById(data) {
  return request({
    url: '/health-recommend/advanceMedicalRecord/getById',
    method: 'GET',
    params: data
  })
}

export function listAdvanceMedicalRecordOperator(data) {
  return request({
    url: '/health-recommend/advanceMedicalRecord/listAdvanceMedicalRecordOperator',
    method: 'POST',
    data
  })
}
// 医生私聊
export function doctorChatForArchives(data) {
  return request({
    url: 'health-doctor-assistant/workOrderCenter/doctorChatForArchives',
    method: 'get',
    params: data
  })
}
// 处方 OCR 识别（线下处方溯源）
export function recognizePrescriptionOcr(data) {
  return request({
    url: `/health-recommend/prescription-ocr/recognize?${data.query}`,
    method: 'POST',
    data: data.params,
    // 当使用 FormData 时，不设置 Content-Type，让浏览器自动设置 multipart/form-data
    headers: { [TokenKey]: getToken(), 'Content-Type': 'multipart/form-data' }
  })
}

// 判断该处方是否上传过药品追溯码
export function judgeTraceRecords(data) {
  return request({
    url: '/health-mall-product/drugPatientTraceRecord/hasTraceRecords',
    method: 'get',
    params: data
  })
}

// 查询处方药品追溯码记录
export function listTraceRecords(data) {
  return request({
    url: '/health-mall-product/drugPatientTraceRecord/listTraceRecords',
    method: 'get',
    params: data
  })
}

// 根据诊断查询复诊日期
export function diagnosisReconsultDate(data) {
  return request({
    url: '/health-cure/cure/diagnosis-reconsult-date/calculate',
    method: 'get',
    params: data
  })
}

// 查询医生是否备案过
export function queryDoctorPass(data) {
  return request({
    url: '/health-doctor/record/passStatus',
    method: 'get',
    params: data
  })
}
